const Loading = ({message, progress}) => {
    // round progress to two decimal places
    progress = progress.toFixed(2);

    return (
        <div className="loading-container">
            <div className="loading-overlay"></div>
            <div className="loading-content">
                {/* animated progress bar */}
                <p>{message}...</p>
                <div className="progress-bar">
                    <div className="progress" style={{width: `${progress}%`}}></div>                    
                </div>
                <p>{progress}%</p>
            </div>
        </div>
    );
}

export default Loading;

